import { atom, useSetAtom } from "jotai";

/** Whether the "Boost on Meta Ads" dialog is open, and the product it was opened for. */
export const boostDialogAtom = atom<{ open: boolean; productId?: string }>({ open: false });

/** Opens the Boost dialog (mounted once in MainLayout), optionally with a product already chosen. */
export function useOpenBoost() {
  const set = useSetAtom(boostDialogAtom);
  return (productId?: string) => set({ open: true, productId });
}

/** The smallest boost budget, in naira. The API enforces its own copy of this (ADS_MIN_BUDGET_NGN). */
export const MIN_BOOST_BUDGET = Number(process.env.REACT_APP_ADS_MIN_BUDGET_NGN) || 5000;
export const BUDGET_PRESETS = [5000, 10000, 20000, 50000];
export const DURATION_PRESETS = [3, 7, 14, 30];

export const naira = (amount: number | string | null | undefined, digits = 0) =>
  `₦${Number(amount || 0).toLocaleString("en-NG", { maximumFractionDigits: digits, minimumFractionDigits: 0 })}`;
